import { defineComponent as _defineComponent } from 'vue';
import { BAlert, BCard, BCardBody, BCardFooter, BCardHeader, BEmbed, BForm, } from "bootstrap-vue";
import { ref } from "vue";
import { useRouter } from "vue-router/composables";
import localize from "@/utils/localization";
import { withPrefix } from "@/utils/redirect";
import NewUserConfirmation from "@/components/Login/NewUserConfirmation.vue";
import ExternalLogin from "@/components/User/ExternalIdentities/ExternalLogin.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoginForm',
    props: {
        sessionCsrfToken: null,
        redirect: null,
        termsUrl: null,
        welcomeUrl: null,
        enableOidc: { type: Boolean },
        showWelcomeWithLogin: { type: Boolean },
        registrationWarningMessage: null
    },
    emits: ["toggle-login", "set-redirect"],
    setup(__props, { emit }) {
        const props = __props;
        const router = useRouter();
        const urlParams = new URLSearchParams(window.location.search);
        const loading = ref(false);
        const messageText = ref("");
        const messageVariant = ref("info");
        const confirmURL = ref(urlParams.has("confirm") && urlParams.get("confirm") == "true");
        function setRedirect(url) {
            localStorage.setItem("redirect_url", url);
        }
        function returnToLogin() {
            router.push("/login/start");
        }
        return { __sfc: true, props, emit, router, urlParams, loading, messageText, messageVariant, confirmURL, setRedirect, returnToLogin, BAlert, BCard, BCardBody, BCardFooter, BCardHeader, BEmbed, BForm, localize, withPrefix, NewUserConfirmation, ExternalLogin };
    }
});
